<template>
    <div>
        <button class="ds-btn" @click="showModal">
            Pievienot
        </button>

        <b-modal :visible="isModalVisible" @hidden="hideModal" no-close-on-backdrop hide-footer body-class="p-2" header-class="bg-light align-items-center" size="lg">
            <div slot="modal-title">
                <h3 class="h4 text-dark font-weight-light m-0">
                    {{ selectedUserGroup._id ? 'Rediģēt darbinieku grupu' : 'Pievienot darbinieku grupu' }}
                </h3>
            </div>
            <div slot="modal-header-close">
            </div>
            <UsersGroupsBaseForm @finished="handleUserGroupCreation"/>
        </b-modal>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import UsersGroupsBaseForm from './UsersGroupsBaseForm';
    import * as userGroupStoreTypes from '../../vuex/modules/user/modules/user-groups/user-group.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';

    export default {
        name: 'user-group-add',
        components: {UsersGroupsBaseForm},
        computed: {
            ...mapGetters('userGroup', {
                /** @type {User|*} */
                selectedUserGroup: userGroupStoreTypes.GET_SELECTED_USER_GROUP,
                /** @type {boolean|*} */
                isModalVisible: userGroupStoreTypes.GET_IS_MODAL_VISIBLE,
            }),
        },
        methods: {
            ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompanyUsersGroups: companyStoreTypes.SET_CURRENT_COMPANY_USERS_GROUPS,
            }),
            ...mapActions('userGroup', {
                /** @type {function|*} */
                getUsersGroups: userGroupStoreTypes.ACTION_GET_USERS_GROUPS,
                /** @type {function|*} */
                showModal: userGroupStoreTypes.ACTION_SHOW_MODAL,
                /** @type {function|*} */
                hideModal: userGroupStoreTypes.ACTION_HIDE_MODAL,
            }),
            async handleUserGroupCreation() {
                this.hideModal();
                const usersGroups = await this.getUsersGroups({companyId: this.$route.params.companyId});
                this.setCurrentCompanyUsersGroups(usersGroups);
            },
        },
    }
</script>